import { Button } from '@/components/ui/button';
import { printFicha } from '@/lib/print/print-actions';
import { usePrintPreview } from '@/lib/print/use-print-preview';
import type { Event } from 'generated/prisma/browser';
import type { ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';
import { Eyebrow } from './primitives';
import { BackToSite, PublicFooterBar, PublicHeader } from './public-chrome';
import { retreatInfo } from './retreat';

interface SubscribeLayoutProps {
  event?: Event | null;
  children: ReactNode;
}

/** Cabeçalho, topo e rodapé compartilhados pela inscrição e pela confirmação. */
export function SubscribeLayout({ event, children }: SubscribeLayoutProps) {
  const info = retreatInfo(event);
  const print = usePrintPreview();

  return (
    <div className="min-h-screen bg-[#F6F6F4] text-body">
      <Helmet>
        <title>Inscrição | Retiro de Casais Enchei-vos — Garanta a vaga do seu casal</title>
        <meta
          name="description"
          content="Inscreva seu casal no Retiro de Casais Enchei-vos, da Comunidade Católica Apóstolos: um fim de semana de oração, partilha e convivência para reacender o amor que Deus uniu. Vagas limitadas."
        />
        <link rel="canonical" href="https://encheivos.onebytedigital.com.br/inscricao" />
        <meta property="og:url" content="https://encheivos.onebytedigital.com.br/inscricao" />
        <meta property="og:title" content="Inscrição | Retiro de Casais Enchei-vos" />
        <meta
          property="og:description"
          content="Garanta a vaga do seu casal no Retiro Enchei-vos. Vagas limitadas."
        />
      </Helmet>

      <PublicHeader>
        <BackToSite />
      </PublicHeader>

      <section className="border-b border-[rgba(11,11,12,.06)] bg-white">
        <div className="mx-auto flex max-w-[1200px] flex-col gap-4 px-6 pt-14 pb-12">
          <Eyebrow>
            {info.hasEvent ? `INSCRIÇÃO • ${info.rangeLong.toUpperCase()}` : 'INSCRIÇÃO'}
          </Eyebrow>
          <h1 className="m-0 max-w-[760px] font-display text-[clamp(34px,4.6vw,56px)] leading-[1.06] font-extrabold tracking-[-0.035em] text-balance text-ink">
            Falta pouco para vocês viverem o Enchei-vos.
          </h1>
          <p className="m-0 max-w-[620px] text-[17px] leading-relaxed text-[#4A4A4F]">
            Preencham os dados do casal abaixo para garantir a participação no retiro.
          </p>
          <div className="flex flex-wrap items-center gap-3">
            <Button
              type="button"
              variant="outline"
              onClick={() => printFicha(print.open, event ?? undefined)}
            >
              Imprimir ficha em papel
            </Button>
            <span className="text-[13px] text-muted">
              Prefere preencher à mão? Imprima e entregue à equipe.
            </span>
          </div>
        </div>
      </section>

      {children}

      <footer className="border-t border-[rgba(11,11,12,.08)] bg-white">
        <PublicFooterBar className="mx-auto max-w-[1200px] px-6 py-7" />
      </footer>

      {print.dialog}
    </div>
  );
}
